import { FC, useContext, useEffect, useMemo } from 'react';
import { createGQLDataContext } from 'utils/createDataContext';
import { useGQLQuery } from 'hooks';
import { FetchSharingDetailsQuery, Community } from 'types/graphql';
import { GQLAPIContextType } from 'types/common.types';
import { fetchSharingDetailsConfig } from 'pages/SettingsPage/modals/ShiftDistributionRulesTieringModal/ShiftDistributionRulesTieringModal.constants';
import { SharingData } from 'pages/SettingsPage/modals/ShiftDistributionRulesTieringModal/ShiftDistributionRulesTieringModal.types';

export const SharingDetailsDataContext = createGQLDataContext<GQLAPIContextType<SharingData>>();

export const SharingDetailsDataProvider: FC = ({ children }) => {
  const sharingDetailsData = useGQLQuery<FetchSharingDetailsQuery, Community[], {}>(
    fetchSharingDetailsConfig(),
  );

  useEffect(() => {
    sharingDetailsData.fetch();
  }, []); // eslint-disable-line

  const contextValues = useMemo(() => {
    return {
      sharingCommunities: [...sharingDetailsData.data],
    };
  }, [sharingDetailsData]);

  return (
    <SharingDetailsDataContext.Provider value={contextValues}>
      {children}
    </SharingDetailsDataContext.Provider>
  );
};

export const useSharingDetailsDataContext = (): GQLAPIContextType<SharingData> =>
  useContext(SharingDetailsDataContext);
